import { captureException } from "@sentry/react"
import { WARP_ME_EXTERNAL_LINKS } from "@warpme/ui"
import { useCallback } from "react"
import { useToast } from "@/components/ui/use-toast"
import { CreateUserError, isMaximumNumberOfGiftsReachedError } from "./api-errors"
import { InvalidCredentialError } from "./errors"

export const useErrorHandler = (showToast = true) => {
  const toast = useToast()

  const handleError = useCallback(
    (error: unknown) => {
      captureException(error)

      if (!showToast) return

      if (error instanceof InvalidCredentialError) {
        toast.error({
          title: "ログインに失敗しました",
          description: "メールアドレスとパスワードを確かめてください",
        })
      } else if (isMaximumNumberOfGiftsReachedError(error)) {
        toast.error({
          title: "eギフトの公開に失敗しました",
          description: "プランを変更するか、非公開として保存してください。",
          action: {
            label: "プランを変更する",
            onClick: () =>
              window.open(
                WARP_ME_EXTERNAL_LINKS.tenant.planChange,
                "_blank",
                "noopener,noreferrer"
              ),
          },
        })
      } else if (error instanceof CreateUserError && error.code === "auth/email-already-exists") {
        toast.error({
          title: "ユーザー登録に失敗しました",
          description: "入力されたメールアドレスはすでに使用されています",
        })
      } else {
        toast.error({
          title: "予期しないエラーが発生しました",
          description: "時間をおいて再度試してください",
        })
      }
    },
    [toast, showToast]
  )

  return { handleError } as const
}
